import { createSelector } from 'reselect';
import { getQueryAsObject } from '@utils/domRouter';

export const getForceFormQuery = createSelector(
  (state, { location }) => getQueryAsObject(location),
  query => query?.forceForm === 'true' || false,
);
